import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from '../auth/auth-guard.service';
import {UserEditComponent} from './user-edit/user-edit.component';
import {UserEditTypeComponent} from './user-edit-type/user-edit-type.component';

const userRoutes: Routes = [
  {
    path: 'user/register', component: UserEditComponent, canActivate: []
  },
  {
    path: 'user/register/type', component: UserEditTypeComponent, canActivate: []
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(userRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class UserRoutingModule {}
